import { cn } from "@babackapp/ui/lib/utils";
import NumberFlow from "@number-flow/react";
import { StatCard } from "./stat-card";
import { StatProgress } from "./stat-progress";

type QuickStatCardProps = {
  count: number;
  value: number;
  currency: string;
  evolution: number;
  title: string;
  subtitle: string;
  percentage: number;
  color: string;
};

export function QuickStatCard({
  count,
  value,
  title,
  currency,
  subtitle,
  percentage,
  color,
}: QuickStatCardProps) {
  return (
    <StatCard>
      <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 mb-2">
          <div
            className="w-2 h-2 rounded-full hidden sm:block"
            style={{ backgroundColor: color }}
          />
          <span className="font-medium text-xs">{title}</span>
        </div>
        <div className="flex sm:flex-row flex-col gap-2 items-baseline">
          <span className="font-semibold text-xl">
            <NumberFlow value={count} />
          </span>
          <NumberFlow
            value={value}
            format={{
              currencyDisplay: "narrowSymbol",
              currency,
              style: "currency",
            }}
            className={cn(
              "text-green-500 font-semibold text-xs",
              !value && "opacity-0",
            )}
          />
        </div>
        <span className="font-medium text-muted-foreground text-xs hidden sm:block">
          {subtitle}
        </span>
      </div>
      <StatProgress percentage={percentage} color={color} />
    </StatCard>
  );
}
